/*
|--------------------------------------------------------------------------
| Account
|--------------------------------------------------------------------------
*/
// Mutations

export const MUTATE_ACCOUNT_DATA = 'account/MUTATE_ACCOUNT_DATA'
export const MUTATE_DELIVERY_DETAILS_STATUS = 'account/MUTATE_DELIVERY_DETAILS_STATUS '
export const MUTATE_DELIVERY_DETAILS_BUSY = 'account/MUTATE_DELIVERY_DETAILS_BUSY'
export const MUTATE_INVOICE_DETAILS_STATUS = 'account/MUTATE_INVOICE_DETAILS_STATUS'
export const MUTATE_INVOICE_DETAILS_BUSY = 'account/MUTATE_INVOICE_DETAILS_BUSY'
export const MUTATE_LOGIN_DETAILS_STATUS = 'account/MUTATE_LOGIN_DETAILS_STATUS'
export const MUTATE_LOGIN_DETAILS_BUSY = 'account/MUTATE_LOGIN_DETAILS_BUSY'
export const MUTATE_PASSWORD_DETAILS_STATUS = 'account/MUTATE_PASSWORD_DETAILS_STATUS'
export const MUTATE_PASSWORD_DETAILS_BUSY = 'account/MUTATE_PASSWORD_DETAILS_BUSY'
export const MUTATE_OPENING_HOURS_DETAILS_STATUS = 'account/MUTATE_OPENING_HOURS_DETAILS_STATUS'
export const MUTATE_OPENING_HOURS_DETAILS_BUSY = 'account/MUTATE_OPENING_HOURS_DETAILS_BUSY'
export const MUTATE_PERSONAL_DETAILS_STATUS = 'account/MUTATE_PERSONAL_DETAILS_STATUS'
export const MUTATE_PERSONAL_DETAILS_BUSY = 'account/MUTATE_PERSONAL_DETAILS_BUSY'
export const MUTATE_COMPANY_DETAILS_STATUS = 'account/MUTATE_COMPANY_DETAILS_STATUS'
export const MUTATE_COMPANY_DETAILS_BUSY = 'account/MUTATE_COMPANY_DETAILS_BUSY'
export const MUTATE_UNLOADING_DETAILS_STATUS = 'account/MUTATE_UNLOADING_DETAILS_STATUS'
export const MUTATE_UNLOADING_DETAILS_BUSY = 'account/MUTATE_UNLOADING_DETAILS_BUSY'

// Actions
export const FETCH_ACCOUNT_DATA = 'account/FETCH_ACCOUNT_DATA'
export const SAVE_DELIVERY_DETAILS = 'account/SAVE_DELIVERY_DETAILS'
export const SAVE_INVOICE_DETAILS = 'account/SAVE_INVOICE_DETAILS'
export const SAVE_LOGIN_DETAILS = 'account/SAVE_LOGIN_DETAILS'
export const SAVE_PASSWORD_DETAILS = 'account/SAVE_PASSWORD_DETAILS'
export const SAVE_OPENING_HOURS_DETAILS = 'account/SAVE_OPENING_HOURS_DETAILS'
export const SAVE_PERSONAL_DETAILS = 'account/SAVE_PERSONAL_DETAILS'
export const SAVE_COMPANY_DETAILS = 'account/SAVE_COMPANY_DETAILS'
export const SAVE_UNLOADING_DETAILS = 'account/SAVE_UNLOADING_DETAILS'

/*
|--------------------------------------------------------------------------
| Auth
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_LOGGED_IN_USER = 'auth/MUTATE_LOGGED_IN_USER'
export const MUTATE_CLEAR_AUTH = 'auth/MUTATE_CLEAR_AUTH'
export const MUTATE_LOGIN_FAILED = 'auth/MUTATE_LOGIN_FAILED'
export const MUTATE_LOGIN_BUSY = 'auth/MUTATE_LOGIN_BUSY'
export const MUTATE_LOGIN_ERROR = 'auth/MUTATE_LOGIN_ERROR'
export const MUTATE_FORGOT_PASSWORD_STATUS = 'auth/MUTATE_FORGOT_PASSWORD_STATUS'
export const MUTATE_FORGOT_PASSWORD_BUSY = 'auth/MUTATE_FORGOT_PASSWORD_BUSY'
export const MUTATE_PASSWORD_RESET_STATUS = 'auth/MUTATE_PASSWORD_RESET_STATUS'
export const MUTATE_PASSWORD_RESET_BUSY = 'auth/MUTATE_PASSWORD_RESET_BUSY'
export const MUTATE_PASSWORD_CHANGED = 'auth/MUTATE_PASSWORD_CHANGED'
// Actions
export const CHANGE_PASSWORD = 'auth/ACTION_CHANGE_PASSWORD'
export const LOGIN = 'auth/ACTION_LOGIN'
export const LOGOUT = 'auth/ACTION_LOGOUT'
export const FORGOT_PASSWORD = 'auth/ACTION_FORGOT_PASSWORD'
export const RESET = 'auth/ACTION_RESET'

/*
|--------------------------------------------------------------------------
| Customer
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_REGISTER_STATUS = 'customer/MUTATE_REGISTER_STATUS'
export const MUTATE_REGISTER_BUSY = 'customer/MUTATE_REGISTER_BUSY'
export const MUTATE_REGISTER_DATA = 'customer/MUTATE_REGISTER_DATA'

// Actions
export const SAVE_REGISTRATION_DATA = 'customer/SAVE_REGISTRATION_DATA'
export const REGISTER = 'customer/REGISTER'

/*
|--------------------------------------------------------------------------
| Dashboard
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_PUSH_ORDERS = 'dashboard/MUTATE_PUSH_ORDERS'
export const MUTATE_SET_ORDERS = 'dashboard/MUTATE_SET_ORDERS'
export const MUTATE_LOADING_ORDERS = 'dashboard/MUTATE_LOADING_ORDERS'
export const MUTATE_IS_SEARCHING_ORDERS = 'dashboard/MUTATE_IS_SEARCHING_ORDERS'
export const MUTATE_HAS_MORE_ORDERS = 'dashboard/MUTATE_HAS_MORE_ORDERS'
export const MUTATE_PUSH_QUOTATIONS = 'dashboard/MUTATE_PUSH_QUOTATIONS'
export const MUTATE_SET_QUOTATIONS = 'dashboard/MUTATE_SET_QUOTATIONS'
export const MUTATE_IS_SEARCHING_QUOTATIONS = 'dashboard/MUTATE_IS_SEARCHING_QUOTATIONS'
export const MUTATE_LOADING_QUOTATIONS = 'dashboard/MUTATE_IS_SEARCHING_QUOTATIONS'
export const MUTATE_HAS_MORE_QUOTATIONS = 'dashboard/MUTATE_HAS_MORE_QUOTATIONS'
export const MUTATE_REMOVE_QUOTATION = 'dashboard/MUTATE_REMOVE_QUOTATION'
export const MUTATE_DOWNLOADING_ORDER = 'dashboard/MUTATE_DOWNLOADING_ORDER'
export const MUTATE_IS_LOADING_QUOTATION_TO_TOOL = 'dashboard/MUTATE_IS_LOADING_QUOTATION_TO_TOOL'

// Actions
export const CLEAR_ORDERS = 'dashboard/ACTION_CLEAR_ORDERS'
export const SEARCH_ORDERS = 'dashboard/ACTION_SEARCH_ORDERS'
export const FETCH_ORDERS = 'dashboard/ACTION_FETCH_ORDERS'
export const COPY_ORDER = 'dashboard/ACTION_COPY_ORDER'
export const DOWNLOAD_ORDER = 'dashboard/ACTION_DOWNLOAD_ORDER'
export const CLEAR_QUOTATIONS = 'dashboard/ACTION_CLEAR_QUOTATIONS'
export const SEARCH_QUOTATIONS = 'dashboard/ACTION_SEARCH_QUOTATIONS'
export const FETCH_QUOTATIONS = 'dashboard/ACTION_FETCH_QUOTATIONS'
export const COPY_QUOTATION = 'dashboard/ACTION_COPY_QUOTATION'
export const DELETE_QUOTATION = 'dashboard/ACTION_DELETE_QUOTATION'

/*
|--------------------------------------------------------------------------
| Textmessages
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_PUSH_TEXTMESSAGES = 'textmessages/MUTATE_PUSH_TEXTMESSAGES'
export const MUTATE_LOADING_TEXTMESSAGES = 'textmessages/MUTATE_LOADING_TEXTMESSAGES'

// Actions
export const FETCH_TEXTMESSAGES = 'textmessages/FETCH_TEXTMESSAGES'

/*
|--------------------------------------------------------------------------
| Excel
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_EXCEL_UPLOAD_STATUS = 'excel/MUTATE_EXCEL_UPLOAD_STATUS'
export const MUTATE_EXCEL_UPLOAD_PROGRESS = 'excel/MUTATE_EXCEL_UPLOAD_PROGRESS'
export const MUTATE_EXCEL_UPLOAD_BUSY = 'excel/MUTATE_EXCEL_UPLOAD_BUSY'

// Actions
export const UPLOAD_EXCEL = 'excel/UPLOAD_EXCEL'

/*
|--------------------------------------------------------------------------
| Order
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_LOADING_QUOTATION_DETAILS = 'order/MUTATE_LOADING_QUOTATION_DETAILS'
export const MUTATE_CONFIRMING_ORDER = 'order/MUTATE_CONFIRMING_ORDER'
export const MUTATE_QUOTATION_DETAILS = 'order/MUTATE_QUOTATION_DETAILS'
export const MUTATE_DELIVERY_DATE = 'order/MUTATE_DELIVERY_DATE'
export const MUTATE_DELIVERY_ADDRESS = 'order/MUTATE_DELIVERY_ADDRESS'
export const MUTATE_CONFIRMATION_DETAILS = 'order/MUTATE_CONFIRMATION_DETAILS'
export const MUTATE_VALIDATING_ORDER = 'order/MUTATE_VALIDATING_ORDER'
export const MUTATE_VALIDATING_ORDER_ERROR = 'order/MUTATE_VALIDATING_ORDER_ERROR'
export const MUTATE_SERVERTIME = 'order/MUTATE_SERVERTIME'

// Actions
export const FETCH_QUOTATION_DETAILS = 'order/ACTION_FETCH_QUOTATION_DETAILS'
export const UPDATE_DELIVERY_DETAILS = 'order/ACTION_UPDATE_DELIVERY_DETAILS'
export const CONFIRM_ORDER = 'order/ACTION_CONFIRM_ORDER'
export const FETCH_SERVERTIME = 'order/ACTION_FETCH_SERVERTIME'

/*
|--------------------------------------------------------------------------
| Order-details
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_LOADING_ORDER_DETAILS = 'order/MUTATE_LOADING_ORDER_DETAILS'
export const MUTATE_ORDER_DETAILS = 'order/MUTATE_ORDER_DETAILS'

// Actions
export const FETCH_ORDER_DETAILS = 'order/ACTION_FETCH_ORDER_DETAILS'

/*
|--------------------------------------------------------------------------
| Products
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_FILTERS = 'product/MUTATE_FILTERS'
export const MUTATE_FILTERS_BRUTO = 'product/MUTATE_FILTERS_BRUTO'
export const MUTATE_LOADING_FILTERS = 'product/MUTATE_LOADING_FILTERS'
export const MUTATE_PRODUCTS = 'product/MUTATE_PRODUCTS'
export const MUTATE_LOADING_PRODUCTS = 'product/MUTATE_LOADING_PRODUCTS'
export const MUTATE_SIDES = 'product/MUTATE_SIDES'
export const MUTATE_LOADING_SIDES = 'product/MUTATE_LOADING_SIDES'

// Actions
export const FETCH_FILTERS = 'product/FETCH_FILTERS'
export const FETCH_PRODUCTS = 'product/FETCH_PRODUCTS'
export const FETCH_SIDES = 'product/FETCH_SIDES'

/*
|--------------------------------------------------------------------------
| Tool
|--------------------------------------------------------------------------
*/
// Mutations
export const MUTATE_CART_REFERENCE = 'tool/MUTATE_CART_REFERENCE'
export const MUTATE_CART_RESTMATERIALS = 'tool/MUTATE_CART_RESTMATERIALS'
export const MUTATE_CART = 'tool/MUTATE_CART'
export const MUTATE_LOAD_QUOTATION = 'tool/MUTATE_LOAD_QUOTATION'
export const MUTATE_SELECTED_MATERIAL = 'tool/MUTATE_SELECTED_MATERIAL'
export const MUTATE_INTERNAL_REFERENCE = 'tool/MUTATE_INTERNAL_REFERENCE'
export const MUTATE_ADD_MATERIAL = 'tool/MUTATE_ADD_MATERIAL'
export const MUTATE_MATERIALS = 'tool/MUTATE_MATERIALS'
export const MUTATE_FILTER_DELIVERYPROGRAM = 'tool/MUTATE_FILTER_DELIVERYPROGRAM'
export const MUTATE_FILTER_FIRST = 'tool/MUTATE_FILTER_FIRST'
export const MUTATE_BRUTO = 'tool/MUTATE_BRUTO'
export const MUTATE_FILTER_SECOND = 'tool/MUTATE_FILTER_SECOND'
export const MUTATE_FILTER_THIRD = 'tool/MUTATE_FILTER_THIRD'
export const MUTATE_THICKNESS = 'tool/MUTATE_THICKNESS'
export const MUTATE_PRODUCT = 'tool/MUTATE_PRODUCT'
export const MUTATE_CODE = 'tool/MUTATE_CODE'
export const MUTATE_SIDE_1 = 'tool/MUTATE_SIDE_1'
export const MUTATE_SIDE_2 = 'tool/MUTATE_SIDE_2'
export const MUTATE_FINISH = 'tool/MUTATE_FINISH'
export const MUTATE_TOTAL_THICKNESS = 'tool/MUTATE_TOTAL_THICKNESS'
export const MUTATE_TOTAL_LENGTH = 'tool/MUTATE_TOTAL_LENGTH'
export const MUTATE_TOTAL_WIDTH = 'tool/MUTATE_TOTAL_WIDTH'
export const MUTATE_TOTAL_DIMENSIONS = 'tool/MUTATE_TOTAL_DIMENSIONS'
export const MUTATE_PANELS = 'tool/MUTATE_PANELS'
export const MUTATE_IS_LOADING_MATERIAL = 'tool/MUTATE_IS_LOADING_MATERIAL'
export const MUTATE_SAVING_ORDER = 'tool/MUTATE_SAVING_ORDER'
export const MUTATE_SAVING_ORDER_REDIRECT = 'tool/MUTATE_SAVING_ORDER_REDIRECT'
export const MUTATE_VALIDATING_PANEL_ROWS = 'tool/MUTATE_VALIDATING_PANEL_ROWS'
export const MUTATE_ORDER_ERROR = 'tool/MUTATE_ORDER_ERROR'
export const MUTATE_CALCULATING_STATUS = 'tool/MUTATE_CALCULATING_STATUS'
export const MUTATE_PRICE_DETAILS = 'tool/MUTATE_PRICE_DETAILS'
export const MUTATE_SAWING_SCHEDULE_DETAILS = 'tool/MUTATE_SAWING_SCHEDULE_DETAILS'
export const MUTATE_ENABLE_COMPONENT = 'tool/MUTATE_ENABLE_COMPONENT'
export const MUTATE_DISABLE_PANEL_INPUT = 'tool/MUTATE_DISABLE_PANEL_INPUT'
export const MUTATE_DISABLE_EXCEL_UPLOAD = 'tool/MUTATE_DISABLE_EXCEL_UPLOAD'

// Actions
export const RESET_CART = 'tool/RESET_CART'
export const SAVE_ORDER = 'tool/SAVE_ORDER'
export const SAVE_ORDER_REDIRECT = 'tool/SAVE_ORDER_REDIRECT'
export const SAVE_ORDER_LOCAL_STORAGE = 'tool/SAVE_ORDER_LOCAL_STORAGE'
export const SET_REFERENCE = 'tool/SET_REFERENCE'
export const SET_RESTMATERIALS = 'tool/SET_RESTMATERIALS'
export const LOAD_QUOTATION = 'tool/ACTION_LOAD_QUOTATION'
export const TOOL_LOAD_CART_FROM_LOCAL_STORAGE = 'tool/TOOL_LOAD_CART_FROM_LOCAL_STORAGE'
export const ORDER_LOAD_CART_FROM_LOCAL_STORAGE = 'tool/ORDER_LOAD_CART_FROM_LOCAL_STORAGE'
export const LOAD_ORDER_FROM_IMPORT = 'tool/LOAD_ORDER_FROM_IMPORT'
export const SELECT_MATERIAL = 'tool/ACTION_SELECT_MATERIAL'
export const REMOVE_PANEL = 'tool/ACTION_REMOVE_PANEL'
export const CALCULATE_ORDER = 'tool/ACTION_CALCULATE_ORDER'
export const ADD_MATERIAL = 'tool/ADD_MATERIAL'
export const REMOVE_MATERIAL = 'tool/REMOVE_MATERIAL'
export const SET_MATERIAL_FILTER_DELIVERYPROGRAM = 'tool/SET_MATERIAL_FILTER_DELIVERYPROGRAM'
export const SET_MATERIAL_FILTER_FIRST = 'tool/SET_MATERIAL_FILTER_FIRST'
export const SET_MATERIAL_BRUTO = 'tool/SET_MATERIAL_BRUTO'
export const SET_MATERIAL_FILTER_SECOND = 'tool/SET_MATERIAL_FILTER_SECOND'
export const SET_MATERIAL_FILTER_THIRD = 'tool/SET_MATERIAL_FILTER_THIRD'
export const SET_MATERIAL_THICKNESS = 'tool/SET_MATERIAL_THICKNESS'
export const SET_MATERIAL_PRODUCT = 'tool/SET_MATERIAL_PRODUCT'
export const SET_MATERIAL_CODE = 'tool/SET_MATERIAL_CODE'
export const SET_MATERIAL_SIDE = 'tool/SET_MATERIAL_SIDE'
export const SET_MATERIAL_FINISH = 'tool/SET_MATERIAL_FINISH'
export const SET_MATERIAL_TOTAL_THICKNESS = 'tool/SET_MATERIAL_TOTAL_THICKNESS'
export const SET_MATERIAL_TOTAL_LENGTH = 'tool/SET_MATERIAL_TOTAL_LENGTH'
export const SET_MATERIAL_TOTAL_WIDTH = 'tool/SET_MATERIAL_TOTAL_WIDTH'
export const SET_MATERIAL_TOTAL_DIMENSIONS = 'tool/SET_MATERIAL_TOTAL_DIMENSIONS'
export const SET_DISABLE_PANEL_INPUT = 'tool/SET_DISABLE_PANEL_INPUT'
export const SET_DISABLE_EXCEL_UPLOAD = 'tool/SET_DISABLE_EXCEL_UPLOAD'
